import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config'; // Import API base URL
import { useDarkMode } from '../DarkModeContext';
import '../App.css';
import UGHSLogo from '../UGHS_LOGO_1.png';
import { subjects } from '../subjects';

function Home() {
  const { dark, setDark } = useDarkMode();
  const navigate = useNavigate();
  // const studentName = localStorage.getItem('student_name');
  // const [isMenuOpen, setIsMenuOpen] = useState(false);

 
  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const checkSession = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/auth/session`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          localStorage.removeItem('token');
          localStorage.removeItem('student_name');
          localStorage.removeItem('student_roll_no');
          navigate('/login');
        }
      } catch (error) {
        navigate('/login');
      }
    };

    checkSession();
  }, [navigate]);

  return (
    <div className={`min-h-screen w-full flex flex-col ${dark
      ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white'
      : 'bg-gradient-to-br from-blue-100 via-white to-blue-200 text-gray-900'
    } transition-colors duration-500`}>

      {/* Fixed Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm z-50">
        <div className="h-16 px-4 sm:px-6 flex items-center justify-end w-full">
          <div className="flex items-center space-x-3 sm:space-x-4">
            <button
              className={`p-2 rounded-full shadow-lg border-2 transition-all duration-300 transform hover:scale-110
                ${dark 
                  ? 'bg-gray-700 text-yellow-300 border-yellow-400 hover:bg-gray-600' 
                  : 'bg-white text-yellow-600 border-yellow-500 hover:bg-yellow-50'}`}
              onClick={() => setDark((d) => !d)}
              aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
              title={dark ? 'Light Mode' : 'Dark Mode'}
            >
              {dark ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000-svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
              )}
            </button>

            <button
              onClick={handleLogout}
              className={`px-3 py-2 rounded-lg font-semibold shadow-lg border-2 flex items-center space-x-1.5
                transition-all duration-300 transform hover:scale-105
                ${dark 
                  ? 'bg-red-700 text-white border-red-600 hover:bg-red-600' 
                  : 'bg-red-100 text-red-700 border-red-200 hover:bg-red-50'}`}
              title="Logout"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
              </svg>
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 w-full pt-20 pb-20 px-4 overflow-y-auto">
        <div className="max-w-4xl mx-auto flex flex-col items-center">
          {/* Logo */}
          <div className="mb-6 sm:mb-8">
            <img
              src={UGHSLogo}
              alt="UGHS Logo"
              className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48
                object-cover drop-shadow-2xl rounded-full border-4 border-blue-400
                transition-transform duration-500 hover:scale-105
                hover:shadow-blue-400/50 shadow-blue-300/30"
            />
          </div>

          {/* Title */}
          <h1 className={`
            text-3xl sm:text-4xl md:text-5xl font-extrabold mb-6 sm:mb-8 text-center
            ${dark ? 'text-blue-200' : 'text-blue-900'}
          `}>
            <span className="inline-block animate-bounce-slow">U</span>
            <span className="inline-block animate-bounce-slower">G</span>
            <span className="inline-block animate-bounce">H</span>
            <span className="inline-block animate-bounce-slower">S</span>
            <span className="mx-2">Question Paper Generator</span>
          </h1>

          {/* Subject Buttons */}
          <div className="w-full">
            <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full">
              {Object.keys(subjects).map((subject) => (
                <button
                  key={subject}
                  className={`
                    font-bold py-3 sm:py-4 px-4 rounded-xl shadow-lg text-base sm:text-lg
                    transition-all duration-200 transform hover:scale-105
                    ${dark
                      ? 'bg-blue-800 hover:bg-blue-900 text-blue-100'
                      : 'bg-blue-200 hover:bg-blue-400 text-blue-900'
                    }
                  `}
                  onClick={() => navigate(`/${subject}/chapters`)}
                >
                  {subject}
                </button>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className={`py-4 px-4 w-full border-t ${dark ? 'border-gray-700' : 'border-gray-300'} ${dark ? 'bg-gray-800 text-blue-200' : 'bg-gray-200 text-blue-800'}`}>
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-sm sm:text-base font-medium">
                &copy; {new Date().getFullYear()} Unique Grammar School. All rights reserved.
              </p>
            </div>
            <div className="text-center md:text-right">
              <p className="text-xs sm:text-sm">
                <span className="font-medium">Address:</span> Saroornagar, Adarsh Nagar,<br className="hidden sm:inline" />
                Saroor Nagar East, Champapet,<br className="hidden sm:inline" />
                Hyderabad, Telangana 500059, India
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;